import { useScript } from '@bnnvara/react-hooks';
import trimEnd from 'lodash/trimEnd';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import trackPage from './trackPage';

const AtInternet = ({
  id,
  siteInfo: {
    level2,
    chapter1
  },
  routerEvents
}) => {
  const sdkScriptUrl = `https://tag.aticdn.net/${id}/smarttag.js`;
  const npoHub = 'https://hub.npo-data.nl/tags/tag.min.js';
  const [sdkLoaded, hasError] = useScript(sdkScriptUrl);
  useScript(npoHub);

  if (hasError) {
    // eslint-disable-next-line no-console
    console.error(`Unable to load ATInternet script: ${sdkScriptUrl}`);
  }

  useEffect(() => {
    if (process.browser && sdkLoaded && !hasError) {
      const sendPage = () => {
        const url = window.location.pathname + window.location.search; // Replace some stuff (/ for empty string, slashes for :: and + signs for -)

        const formattedUrl = url.replace(/^\//g, '').replace(/\//g, '::').replace(/\+/g, '-'); // Trims :: on the end of a string.

        const trimsEnd = trimEnd(formattedUrl, /::(?=.*::)/); // Removes ? and everything behind it.

        const trimmedUrl = trimsEnd.split('?')[0].split('#')[0];
        const chapterLength = chapter1.length + 2; // checks if the url starts with chapter or with /artikelen and trims first part of the url if necessary

        let defUrl = url.startsWith(`/${chapter1}`) && !url.startsWith('/artikelen') ? trimmedUrl.slice(chapterLength) : trimmedUrl; // if the url is the homepage replace it with home

        if (!defUrl) {
          defUrl = 'home';
        } // pushes the siteInfo to at internet tag


        const siteInfo = {
          name: defUrl,
          level2,
          chapter1
        }; // sets the custom variables and send it to the at internet tag

        const customVars = {
          site: {
            1: '[site]',
            2: '[bnnvara]',
            3: `[${chapter1}]`,
            4: '[standalone]',
            6: '[index]',
            7: '[general]'
          }
        }; // sends all values to at internet

        trackPage(siteInfo, customVars);
      };

      sendPage();
      routerEvents.on('routeChangeComplete', sendPage);
      return () => routerEvents.off('routeChangeComplete', sendPage);
    }

    return () => null;
  }, [chapter1, level2, sdkLoaded, hasError, routerEvents]);
  return null;
};

AtInternet.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  siteInfo: PropTypes.shape({
    level2: PropTypes.string.isRequired,
    chapter1: PropTypes.string.isRequired
  }).isRequired,
  routerEvents: PropTypes.shape({
    on: PropTypes.func.isRequired,
    off: PropTypes.func.isRequired
  }).isRequired
};
export default AtInternet;